export default "__VITE_ASSET__CzxzoFXL__"